// extracted by mini-css-extract-plugin
module.exports = {"printerConfigModal":"PrinterConfigModal_printerConfigModal__2Fxr-"};